// extracted by mini-css-extract-plugin
export var rateListItem = "ArticleRatedFeaturesListItem-module--rateListItem--3Y127";
export var rateListTitle = "ArticleRatedFeaturesListItem-module--rateListTitle--7cqTa";
export var rateBar = "ArticleRatedFeaturesListItem-module--rateBar--3kmcv";
export var rateBarFilled = "ArticleRatedFeaturesListItem-module--rateBarFilled--2Wjao";
export var rateBarCircle = "ArticleRatedFeaturesListItem-module--rateBarCircle--qFUmC";
export var rateBarScore = "ArticleRatedFeaturesListItem-module--rateBarScore--2ySFo";